import { AUTOCOMPLETE_URL } from '@global/App/constants/constants';
import { AutocompleteItem, GetAutocomplete, SuggestAddress } from './types';

type RequestAutocompleteDataParams = {
  zipCode: string;
  countryCode: string;
};

const requestAutocompleteData = async ({
  zipCode,
  countryCode,
}: RequestAutocompleteDataParams): Promise<AutocompleteItem[]> => {
  try {
    const baseUrl = AUTOCOMPLETE_URL;
    const searchParams = `POSTAL_CD:${zipCode} AND ISO_ALPHA_2:${countryCode}`;
    const query = new URLSearchParams({ q: searchParams }).toString();
    const url = `${baseUrl}?${query}`;

    const response = await fetch(url);
    const result: GetAutocomplete = await response.json();
    return result.response.docs;
  } catch (error) {
    console.error('Autocomplete request has been failed: ' + error);
    return [] as AutocompleteItem[];
  }
};

export const getSuggestions = async (
  params: RequestAutocompleteDataParams
): Promise<SuggestAddress[]> => {
  const docs = await requestAutocompleteData(params);

  return docs.map((item) => ({ state: item.ADMIN_NM1, city: item.PLACE_NM }));
};
